const setNewTime = (type, newTime) => {
	return {
	  type: "SET_NEW_TIME",
		newTime: newTime,
	};
  };
  
  export default {
	setNewTime
  };